module.exports = __webpack_public_path__ + "img/footerText.81f8ccc0.png";